import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import * as styles from './Stepper.scss';
var Stepper = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Stepper, _Component);

  var _super = _createSuper(Stepper);

  function Stepper() {
    _classCallCheck(this, Stepper);

    return _super.apply(this, arguments);
  }

  _createClass(Stepper, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(next) {
      if (this.props.onChange && this.props.currentStep !== next.currentStep) {
        if (!this.props.clickableSteps) {
          this.props.onChange(this.props.currentStep, next.currentStep);
        } else {// TODO: Add logic for cases where clickableSteps is true? Unsure if this should be supported.
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          clickableSteps = _this$props.clickableSteps,
          currentStep = _this$props.currentStep,
          steps = _this$props.steps;
      var stepper = steps.map(function (step, index) {
        index++; // step starts at one

        var active = currentStep === index;
        var complete = currentStep > index;
        var activeClass = active ? styles.active : '';
        var completeClass = complete ? styles.complete : '';
        var style = {};

        if (active) {
          style.backgroundColor = _this.props.theme.colors.secondaryColor;
        } else if (complete) {
          style.color = _this.props.theme.colors.secondaryColor;
        }

        var stepInnards = /*#__PURE__*/React.createElement("div", {
          className: "".concat(styles.step, " ").concat(activeClass, " ").concat(completeClass)
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.circle,
          style: active ? {
            backgroundColor: _this.props.theme.colors.secondaryColor
          } : {}
        }, complete ? /*#__PURE__*/React.createElement("i", {
          style: {
            color: _this.props.theme.colors.secondaryColor
          },
          className: "".concat(styles.icon, " icon ion-ios-checkmark-empty")
        }) : index), /*#__PURE__*/React.createElement("div", {
          className: styles.label,
          style: complete ? {
            color: _this.props.theme.colors.secondaryColor
          } : {}
        }, step.label));
        return /*#__PURE__*/React.createElement("div", {
          className: styles.stepWrap,
          key: index
        }, clickableSteps ? /*#__PURE__*/React.createElement(Link, {
          to: step.link
        }, stepInnards) : stepInnards, index < steps.length && /*#__PURE__*/React.createElement("div", {
          className: styles.divider
        }));
      });
      return /*#__PURE__*/React.createElement("div", null, stepper);
    }
  }]);

  return Stepper;
}(Component), _defineProperty(_class2, "defaultProps", {
  clickableSteps: false
}), _defineProperty(_class2, "propTypes", {
  clickableSteps: PropTypes.bool,
  currentStep: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  theme: PropTypes.object
}), _temp)) || _class);
export default Stepper;